import { Selector } from 'reselect'
import { Moment } from 'moment-timezone'
import { ReduxState } from 'store/createRootReducer'

export const subscriptionStatsDatesRangeSelector: Selector<ReduxState, [Moment, Moment]> = state => state.reports.subscriptionStatsDatesRange
export default subscriptionStatsDatesRangeSelector
